/* Budli app install prompt: bottom sheet for phones (iPhone -> App Store, Android -> Google Play)
 * - Shows once ~4s after load; closing it hides it for 7 days; tapping the store button hides it for 60 days
 * - Never shown inside the Budli app itself (user agent contains "BudliApp"), when already running
 *   as an installed web app, on cart/checkout/login pages, or on desktop
 * - Any link ending in "#install-app" opens the prompt on demand (ignores snooze)
 * - Fires GTM dataLayer events: pwa_banner_shown, pwa_install_clicked, pwa_install_dismissed
 */
(function () {
  'use strict';

  var CFG = {
  "site": "buy",
  "ios": "https://apps.apple.com/in/app/budli-buy-sell-used-gadgets/id6815210185?ct=budli_buy_popup",
  "play": "https://play.google.com/store/apps/details?id=com.budli.app&hl=en_IN&referrer=utm_source%3Dbudli_buy%26utm_medium%3Dpopup",
  "icon": "//buy.budli.in/cdn/shop/t/61/assets/icon-app-180.png?v=73031133731149085201784369188",
  "sub": "Faster shopping, live order tracking and first access to deal drops.",
  "delay": 4000
};

  var ua = navigator.userAgent || '';
  var isIos = /iPhone|iPod/.test(ua) || (/iPad/.test(ua));
  var isAndroid = /Android/.test(ua);
  var platform = isIos ? 'ios' : (isAndroid ? 'android' : 'desktop');
  if (platform === 'desktop') return;
  if (/BudliApp/i.test(ua)) return;
  if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true) return;

  var KEY = 'budli-app-prompt-until';
  var SKIP_PATH = /^\/(cart|checkout|login|account|checkouts)(\/|$)/i;

  function get(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function set(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  function track(name, extra) {
    window.dataLayer = window.dataLayer || [];
    var p = { event: name, pwa_platform: platform, pwa_site: CFG.site };
    if (extra) for (var k in extra) p[k] = extra[k];
    window.dataLayer.push(p);
  }

  var sheet = null;

  function css() {
    if (document.getElementById('budli-app-sheet-css')) return;
    var s = document.createElement('style');
    s.id = 'budli-app-sheet-css';
    s.textContent =
      '.bdas{position:fixed;left:0;right:0;bottom:0;z-index:2147483000;background:#fff;border-radius:20px 20px 0 0;' +
      'box-shadow:0 -8px 32px rgba(16,24,40,.18);padding:10px 18px calc(16px + env(safe-area-inset-bottom));' +
      'font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif;color:#111827;' +
      'transform:translateY(105%);transition:transform .35s cubic-bezier(.22,1,.36,1);-webkit-text-size-adjust:100%}' +
      '.bdas.bdas-in{transform:none}' +
      '.bdas *{box-sizing:border-box}' +
      '.bdas-grab{width:38px;height:4px;border-radius:4px;background:#d1d5db;margin:0 auto 12px}' +
      '.bdas-row{display:flex;align-items:center;gap:12px}' +
      '.bdas-ico{width:52px;height:52px;border-radius:12px;flex:none;border:1px solid rgba(0,0,0,.08);background:#fff;object-fit:cover}' +
      '.bdas-txt{flex:1;min-width:0}' +
      '.bdas-t{margin:0;font-size:16px;line-height:1.25;font-weight:800;color:#111827}' +
      '.bdas-s{margin:2px 0 0;font-size:12.5px;line-height:1.35;color:#6b7280}' +
      '.bdas-x{position:absolute;top:8px;right:10px;width:32px;height:32px;border:0;background:none;font-size:24px;line-height:1;color:#9ca3af;cursor:pointer;padding:0}' +
      '.bdas-go{display:flex;align-items:center;justify-content:center;gap:8px;width:100%;height:48px;margin-top:14px;border-radius:999px;' +
      'background:#c10077;color:#fff!important;font-size:15px;font-weight:800;text-decoration:none!important;border:0;letter-spacing:.2px}' +
      '.bdas-go svg{width:18px;height:18px;flex:none}' +
      '.bdas-no{display:block;width:100%;margin-top:6px;padding:10px;border:0;background:none;font-size:13px;font-weight:600;color:#6b7280;cursor:pointer}' +
      '@media (min-width:600px){.bdas{left:50%;right:auto;width:420px;margin-left:-210px}}' +
      '@media (prefers-reduced-motion:reduce){.bdas{transition:none}}';
    document.head.appendChild(s);
  }

  var APPLE = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M16.4 12.6c0-2.3 1.9-3.4 2-3.5-1.1-1.6-2.8-1.8-3.4-1.8-1.4-.15-2.8.85-3.5.85s-1.8-.8-3-.8c-1.5 0-3 .9-3.8 2.3-1.6 2.8-.4 7 1.2 9.3.8 1.1 1.7 2.4 2.9 2.3 1.2 0 1.6-.75 3-.75s1.8.75 3 .72c1.3 0 2.1-1.1 2.8-2.2.9-1.3 1.3-2.5 1.3-2.6-.05 0-2.5-.95-2.5-3.8zM14.2 5.9c.6-.8 1.1-1.9.95-3-.95.05-2.1.65-2.75 1.4-.6.7-1.1 1.8-1 2.9 1.05.1 2.1-.5 2.8-1.3z"/></svg>';
  var PLAY = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M5 3.2v17.6c0 .5.5.8.9.6l14.4-8.8c.4-.2.4-.8 0-1L5.9 2.6c-.4-.2-.9.1-.9.6z"/></svg>';

  function hide() {
    if (!sheet) return;
    var s = sheet; sheet = null;
    s.classList.remove('bdas-in');
    setTimeout(function () { if (s.parentNode) s.parentNode.removeChild(s); }, 400);
  }

  function show(trigger) {
    if (sheet) return;
    css();
    var url = platform === 'ios' ? CFG.ios : CFG.play;
    var label = platform === 'ios' ? 'Get it on the App Store' : 'Get it on Google Play';
    sheet = document.createElement('div');
    sheet.className = 'bdas';
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-label', 'Get the Budli app');
    sheet.innerHTML =
      '<div class="bdas-grab"></div>' +
      '<button type="button" class="bdas-x" aria-label="Close">&times;</button>' +
      '<div class="bdas-row">' +
      '<img class="bdas-ico" src="' + CFG.icon + '" alt="" width="52" height="52">' +
      '<div class="bdas-txt"><p class="bdas-t">Get the Budli app</p>' +
      '<p class="bdas-s">' + CFG.sub + '</p></div></div>' +
      '<a class="bdas-go" href="' + url + '" target="_blank" rel="noopener">' + (platform === 'ios' ? APPLE : PLAY) + '<span>' + label + '</span></a>' +
      '<button type="button" class="bdas-no">Not now</button>';
    document.body.appendChild(sheet);

    function snooze(days) { set(KEY, String(Date.now() + days * 864e5)); }
    sheet.querySelector('.bdas-x').addEventListener('click', function () { snooze(7); track('pwa_install_dismissed', { pwa_trigger: trigger }); hide(); });
    sheet.querySelector('.bdas-no').addEventListener('click', function () { snooze(7); track('pwa_install_dismissed', { pwa_trigger: trigger }); hide(); });
    sheet.querySelector('.bdas-go').addEventListener('click', function () {
      snooze(60);
      track('pwa_install_clicked', { pwa_trigger: trigger, pwa_store: platform === 'ios' ? 'app_store' : 'play' });
      setTimeout(hide, 300);
    });

    track('pwa_banner_shown', { pwa_trigger: trigger });
    requestAnimationFrame(function () { requestAnimationFrame(function () { if (sheet) sheet.classList.add('bdas-in'); }); });
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href$="#install-app"]');
    if (!a) return;
    e.preventDefault();
    show('link');
  });

  if (SKIP_PATH.test(location.pathname)) return;
  var until = parseInt(get(KEY), 10);
  if (until && Date.now() < until) return;
  setTimeout(function () { if (document.visibilityState !== 'hidden') show('auto'); }, CFG.delay || 4000);
})();
